import { EmbeddedMessage } from 'constants/messageMediums';
import { MESSAGE_MEDIUM_CONTENT_MAPPER } from 'modules/campaigns/lib/utils';
import { MessageMedium } from 'modules/domains/campaign';
import styled from 'styled-components';
import { NavTabsList, NavTabTrigger, TabsContent, TabsGroup } from 'ui/tabsGroup';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { useEmbeddedMessagingCoreFeature } from 'utils/hooks/featureFlags';
import { useProjectAlertsContext } from '../../context/ProjectAlertsContext';
import { AlertList } from '../AlertList';
import { MESSAGE_MEDIUMS_TO_CAMPAIGN_TYPES } from '../constants';
import { CampaignTypeCard } from './CampaignTypeCard';

const StyledTabsGroup = styled(TabsGroup)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

const StyledNavTabsList = styled(NavTabsList)`
  margin-left: -${spacing.plusHalf};
  margin-right: -${spacing.plusHalf};
  padding-left: ${spacing.threeQuarter};
  width: auto;
  overflow-x: auto;
  overflow-y: hidden;
`;

const StyledTrigger = styled(NavTabTrigger)`
  gap: ${pxToRem(10)};
`;

/**
 * Prevents the following HTML rule from being broken:
 * <li> cannot appear as a descendant of <li>
 * as Radix UI tabs are also implemented with <li>
 */
const ListWrapper = styled.ul`
  padding: 0;
  margin: 0;
`;

export const MESSAGE_MEDIUM_TABS_ID = 'message-medium-tabs';

export const MessageMediumTabs = () => {
  const isEmbeddedMessagingCampaignsFeatureOn = useEmbeddedMessagingCoreFeature();
  const { allAlertMetrics, isLoadingMetrics, isLoadingProjectCampaignAlerts } =
    useProjectAlertsContext();

  return (
    <StyledTabsGroup data-test={MESSAGE_MEDIUM_TABS_ID} defaultValue={MessageMedium.Email}>
      <StyledNavTabsList>
        {MESSAGE_MEDIUMS_TO_CAMPAIGN_TYPES.map(({ medium }) => {
          const { Icon: MessageMediumIcon, displayName: messageMediumDisplayName } =
            MESSAGE_MEDIUM_CONTENT_MAPPER[medium];
          const isShown = medium !== EmbeddedMessage || isEmbeddedMessagingCampaignsFeatureOn;

          return (
            isShown && (
              <StyledTrigger data-test={`${medium}-tab-trigger`} key={medium} value={medium}>
                <MessageMediumIcon />
                {messageMediumDisplayName}
              </StyledTrigger>
            )
          );
        })}
      </StyledNavTabsList>

      {MESSAGE_MEDIUMS_TO_CAMPAIGN_TYPES.map(({ medium, types }) => {
        const metricsForSelectedMedium = allAlertMetrics[medium];

        return types?.map((typeData) => (
          <TabsContent key={`${medium}-${typeData.type}`} value={medium}>
            <ListWrapper>
              <CampaignTypeCard campaignTypeData={typeData} messageMedium={medium}>
                <AlertList
                  campaignType={typeData.type}
                  isLoading={isLoadingMetrics || isLoadingProjectCampaignAlerts}
                  messageMedium={medium}
                  metrics={metricsForSelectedMedium}
                />
              </CampaignTypeCard>
            </ListWrapper>
          </TabsContent>
        ));
      })}
    </StyledTabsGroup>
  );
};
